import { Outlet } from 'react-router-dom';

import Header from '../components/Header/Header';

const App = () => (
  <>
    <Header />
    <Outlet />
  </>
);
export default App;
